// hooks/useAtualizarDados.ts
import { useState } from "react";
// --------------------- Import Services ---------------------
import { atualizarPostagem } from "../../../services/atualizarPostagemService";
import { atualizarLead } from "../../../services/atualizarLeadService";
import { atualizarFonte } from "../../../services/atualizarFonteServiceService";
import { atualizarGrupo } from "../../../services/atualizarGrupoService";
import dayjs from "dayjs";

export const useAtualizarPostagem = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<boolean | null>(null);
  const [success, setSuccess] = useState<boolean | null>(null);
  const [warning, setWarning] = useState<string | null>(null);
  const resetWarning = () => setWarning(null);

  const verificarLimiteData = (
    dataIni?: string | Date,
    dataFim?: string | Date
  ) => {
    if (!dataIni || !dataFim) return true;

    const ini = dayjs(dataIni);
    const fim = dayjs(dataFim);

    if (fim.isBefore(ini, "day")) {
      return false;
    }

    return true;
  };
  const verificarPeriodoDisponibiliza = (
    dataIni?: string | Date,
    dataFim?: string | Date
  ) => {
    if (!dataIni || !dataFim) return true;

    const ini = dayjs(dataIni);
    const fim = dayjs(dataFim);
    const diff = fim.diff(ini, "day");

    if (diff > 7) {
      return false;
    }

    return true;
  };

  const atualizar = async (
    postagemId: number | undefined,
    postagemData: any,
    leadsId?: number,
    empreendId?: number,
    fonteId?: number,
    grupoId?: number
  ) => {
    setIsLoading(true);
    setError(null);

    const dataLeads = {
      id: leadsId,
      nome: postagemData.idLeads,
    };

    const dataFonte = {
      id: fonteId,
      nome: postagemData.idFonte,
    };
    const dataGrupo = {
      id: grupoId,
      nome: postagemData.idGrupo,
    };

    let postagemDataNovo;

    let attPostagem;

    let atualizarDados;

    if (postagemId && postagemData) {
      if (
        postagemData.idLeads &&
        postagemData.idEmpreendimento &&
        postagemData.idFonte &&
        postagemData.idGrupo
      ) {
        attPostagem = true;
        postagemDataNovo = {
          active: postagemData.active,
          idEmpreendimento: postagemData.idEmpreendimento,
          dataDivulgacao: postagemData.dataDivulgacao,
          tipoInteresse: postagemData.tipoInteresse,
          aluguel: postagemData.aluguel,
          troca: postagemData.troca,
          compra: postagemData.compra,
          venda: postagemData.venda,
          dataIni: postagemData.dataIni,
          dataFim: postagemData.dataFim,
          id: postagemId,
          observacoes: postagemData.observacoes,
        };
      } else {
        attPostagem = false;
        postagemDataNovo = {
          id: postagemId,
          active: postagemData.active,
          idEmpreendimento: empreendId,
          dataDivulgacao: postagemData.dataDivulgacao,
          tipoInteresse: postagemData.tipoInteresse,
          aluguel: postagemData.aluguel,
          troca: postagemData.troca,
          compra: postagemData.compra,
          venda: postagemData.venda,
          dataIni: postagemData.dataIni,
          dataFim: postagemData.dataFim,
          observacoes: postagemData.observacoes,
        };
      }

      try {
        if (attPostagem) {
          if (
            !verificarLimiteData(
              postagemDataNovo.dataIni,
              postagemDataNovo.dataFim
            )
          ) {
            setWarning("A data fim não pode ser menor que a data início.");
            return false;
          }

          if (postagemDataNovo.tipoInteresse === "DISPONIBILIZA") {
            const validacaoDisponibiliza = verificarPeriodoDisponibiliza(
              postagemDataNovo.dataIni,
              postagemDataNovo.dataFim
            );
            if (!validacaoDisponibiliza) {
              setWarning(
                "O período de disponibilização não pode ser maior que 7 dias."
              );
              return false;
            }
          }
          const atualizarLeads = await atualizarLead(dataLeads);

          const fonte = await atualizarFonte(dataFonte);
          const grupo = await atualizarGrupo(dataGrupo);
          atualizarDados = await atualizarPostagem(postagemDataNovo);

          if (atualizarLeads && fonte && grupo && atualizarDados) {
            setSuccess(true);
            setError(false);
          } else {
            setError(true);
            setSuccess(false);
          }
        } else {
          atualizarDados = await atualizarPostagem(postagemDataNovo);
          if (atualizarDados) {
            setSuccess(true);
            setError(false);
          } else {
            setError(true);
            setSuccess(false);
          }
        }
        return atualizarDados;
      } catch (error) {
        console.error(error);
      } finally {
        setIsLoading(false);
      }
    }
  };

  return { atualizar, isLoading, error, success, warning, resetWarning };
};
